{
    "name": "tpf-character-sheet",
    "version": "1.7.0",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build:dev": "ng build --configuration development",
        "build:prod": "ng build --configuration production",
        "watch": "ng build --watch --configuration development",
        "test": "jest",
        "prettier": "npx prettier . --write",
        "prettier:ci": "npx prettier . --check",
        "prepare": "husky"
    },
    "private": true,
    "dependencies": {
        "@angular/cdk": "^20.0.3",
        "@angular/common": "^20.0.4",
        "@angular/compiler": "^20.0.4",
        "@angular/core": "^20.0.4",
        "@angular/forms": "^20.0.4",
        "@angular/material": "^20.0.3",
        "@angular/platform-browser": "^20.0.4",
        "@angular/platform-browser-dynamic": "^20.0.4",
        "@angular/router": "^20.0.4",
        "@ngrx/store": "^19.2.1",
        "@ngrx/store-devtools": "^19.2.1",
        "lodash-es": "^4.17.21",
        "rxjs": "~7.8.0",
        "tslib": "^2.3.0",
        "uuid": "^11.1.0",
        "zone.js": "~0.15.0"
    },
    "devDependencies": {
        "@angular/build": "^20.0.3",
        "@angular/cli": "^20.0.3",
        "@angular/compiler-cli": "^20.0.4",
        "@types/jest": "^29.5.14",
        "@types/lodash-es": "^4.17.12",
        "husky": "^9.1.7",
        "jest": "^29.7.0",
        "jest-junit": "^16.0.0",
        "jest-preset-angular": "^14.6.0",
        "prettier": "^3.5.3",
        "ts-node": "^10.9.2",
        "typescript": "~5.8.3"
    },
    "jest-junit": {
        "suiteName": "jest tests",
        "outputDirectory": "./coverage/junit",
        "outputName": "junit.xml",
        "uniqueOutputName": "false",
        "classNameTemplate": "{classname}-{title}",
        "titleTemplate": "{classname}-{title}",
        "ancestorSeparator": " › ",
        "usePathForSuiteName": "true"
    }
}
